// TODO - Documentar
import React from 'react'

function SimpleFillFooter() {
  return (
    <div style={{height : "65px"}}></div>
  )
}

export default SimpleFillFooter